import axios from 'axios';
import { getMessage, toErrorObject } from './ErrorMessageTranslate';

//deprecated
export const handlePost2 = async (path, param, this2) => {
    axios.post(path, param)
        .then(this2.handleSuccess)
        .catch(error => {
            if (error && error.response && error.response.data && Array.isArray(error.response.data)) {
                // console.log(error.response.data);
                /* eslint-disable array-callback-return */
                error.response.data.map((element, index) => {
                    if (element.fielNames && element.fielNames.size === 0) {
                        this2.props.enqueueSnackbar(getMessage(element), { variant: 'error', persist: true });
                    }
                    if (typeof this2.handleErrors == 'function') {
                        this2.handleErrors(error.response.data);
                    } else {
                        this2.props.enqueueSnackbar(getMessage(element), { variant: 'error', persist: true });
                    }
                })
                /* eslint-enable array-callback-return */
            } else {
                console.log(error);
            }
        })
};

export const handlePdf = (path, param, this2) => {
    axios({
        url: path, //your url
        method: 'POST',
        responseType: 'arraybuffer', // important
        data: param,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/pdf'
        }
    })
        .then((res) => handleSuccessPost(this2, res))
}

export const handlePost = async (path, param, this2) => {
    axios.post(path, param)
        .then((res) => handleSuccessPost(this2, res))
        .catch(error => {
            if (error && error.response && error.response.data && Array.isArray(error.response.data)) {
                console.log(error.response.data);
                /* eslint-disable array-callback-return */
                error.response.data.map((element, index) => {
                    if (element.fieldNames) {
                        console.log(element)
                        if (element.fieldNames.length === 0) {
                            this2.props.enqueueSnackbar(getMessage(element), { variant: 'error', persist: true });
                        } else if (this2.fields && (element.fieldNames.filter(value => this2.fields.includes(value)).length === 0 || this2.fields.length === 0)) {
                            this2.props.enqueueSnackbar(getMessage(element), { variant: 'error', persist: true });
                        } else if (!this2.fields) {
                            this2.props.enqueueSnackbar(getMessage(element), { variant: 'error', persist: true });
                        }
                    } else {
                        this2.props.enqueueSnackbar(getMessage(element), { variant: 'error', persist: true });
                    }
                    if (typeof handleErrors == 'function') {
                        handleErrors(error.response.data, this2);
                    }
                })
                /* eslint-enable array-callback-return */
            } else {
                console.log(error);
            }
        })
};

const handleSuccessPost = (this2, res) => {
    if (typeof this2.props.refresh == 'function') {
        this2.props.refresh();
        if (this2.state && this2.state.newAgain) {
            this2.resetForm();
        } else {
            this2.props.close();
        }
    } else {
        this2.handleSuccess(res);
    }

}

const handleErrors = (errors, this2) => {
    console.log("handleErrors")
    this2.setState({ errors: toErrorObject(errors) });
}

export const handleChangeEvent = (event, this2) => {
    if (event.target && event.target.name) {
        this2.setState({ [event.target.name]: event.target.value })
        if (this2.state.errors) {
            if (this2.state.errors.has(event.target.name)) {
                let copy = this2.state.errors;
                copy.delete(event.target.name);
                this2.setState({ errors: copy });
            }
        } else {
            console.error("no errors");
        }
    } else {
        console.error("no event.target or event.target.name");
    }
}

export const handleDateChangeEvent = (value, fieldName, this2) => {
    this2.setState({ [fieldName]: value });
}

export const handleChangeValue = (value, name, this2) => {
    this2.setState({ [name]: value })
    if (this2.state.errors) {
        if (this2.state.errors.has(name)) {
            let copy = this2.state.errors;
            copy.delete(name);
            this2.setState({ errors: copy });
        }
    } else {
        console.error("no errors");
    }
}

export const handlePatch = async (path, param, this2) => {
    axios.patch(path, param)
        .then(() => handleSuccessPatch(this2))
        .catch(error => {
            if (error && error.response && error.response.data && Array.isArray(error.response.data)) {
                /* eslint-disable array-callback-return */
                error.response.data.map((element, index) => {
                    if (element.fieldNames) {
                        if (element.fieldNames.length === 0) {
                            this2.props.enqueueSnackbar(getMessage(element), { variant: 'error', persist: true });
                        } else if (this2.fields && element.fieldNames.filter(value => this2.fields.includes(value)).length === 0) {
                            console.log(element)
                            this2.props.enqueueSnackbar(getMessage(element), { variant: 'error', persist: true });
                        } else if (!this2.fields) {
                            this2.props.enqueueSnackbar(getMessage(element), { variant: 'error', persist: true });
                        }
                    } else {
                        console.error(element);
                        this2.props.enqueueSnackbar(getMessage(element), { variant: 'error', persist: true });
                    }
                    if (typeof handleErrors == 'function') {
                        handleErrors(error.response.data, this2);
                    }
                })
                /* eslint-enable array-callback-return */
            } else {
                console.log(error);
                console.log(error.response);
            }
        })
};

const handleSuccessPatch = (this2) => {
    console.log("handleSuccessPatch")
    this2.props.refresh();
    this2.props.close();
}
export const handlePatchWithoutClose = async (path, param, this2) => {
    axios.patch(path, param)
        .then(() => handleSuccessPatchWithoutClose(this2))
        .catch(error => {
            if (error && error.response && error.response.data && Array.isArray(error.response.data)) {
                /* eslint-disable array-callback-return */
                error.response.data.map((element, index) => {
                    if (element.fieldNames) {
                        if (element.fieldNames.length === 0) {
                            this2.props.enqueueSnackbar(getMessage(element), { variant: 'error', persist: true });
                        } else if (this2.fields && element.fieldNames.filter(value => this2.fields.includes(value)).length === 0) {
                            console.log(element)
                            this2.props.enqueueSnackbar(getMessage(element), { variant: 'error', persist: true });
                        } else if (!this2.fields) {
                            this2.props.enqueueSnackbar(getMessage(element), { variant: 'error', persist: true });
                        }
                    } else {
                        console.error(element);
                        this2.props.enqueueSnackbar(getMessage(element), { variant: 'error', persist: true });
                    }
                    if (typeof handleErrors == 'function') {
                        handleErrors(error.response.data, this2);
                    }
                })
                /* eslint-enable array-callback-return */
            } else {
                console.log(error);
                console.log(error.response);
            }
        })
};

const handleSuccessPatchWithoutClose = (this2) => {
    console.log("handleSuccessPatch")
    this2.refresh();
}

export const handleDelete = async (path, param, this2) => {
    axios.delete(path, { data: param })
        .then(handleSuccessDelete(this2))
        .catch(error => {
            if (error && error.response && error.response.data && Array.isArray(error.response.data)) {
                // console.log(error.response.data);
                /* eslint-disable array-callback-return */
                error.response.data.map((element, index) => {
                    if (element.fielNames && element.fielNames.size === 0) {
                        this2.props.enqueueSnackbar(getMessage(element), { variant: 'error', persist: true });
                    }
                    if (typeof this2.handleErrors == 'function') {
                        this2.handleErrors(error.response.data);
                    } else {
                        this2.props.enqueueSnackbar(getMessage(element), { variant: 'error', persist: true });
                    }
                })
                /* eslint-enable array-callback-return */
            } else {
                console.log(error);
            }
        })
};

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

const handleSuccessDelete = (this2) => {
    sleep(100).then(() => {
        console.log("handleSuccessDelete")
        this2.props.refresh();
        this2.props.close();
    })
}

export const handleDeleteWithoutClose = async (path, param, this2) => {
    axios.delete(path, { data: param })
        .then(handleSuccessDeleteWithoutClos(this2))
        .catch(error => {
            if (error && error.response && error.response.data && Array.isArray(error.response.data)) {
                // console.log(error.response.data);
                /* eslint-disable array-callback-return */
                error.response.data.map((element, index) => {
                    if (element.fielNames && element.fielNames.size === 0) {
                        this2.props.enqueueSnackbar(getMessage(element), { variant: 'error', persist: true });
                    }
                    if (typeof this2.handleErrors == 'function') {
                        this2.handleErrors(error.response.data);
                    } else {
                        this2.props.enqueueSnackbar(getMessage(element), { variant: 'error', persist: true });
                    }
                })
                /* eslint-enable array-callback-return */
            } else {
                console.log(error);
            }
        })
};

const handleSuccessDeleteWithoutClos = (this2) => {
    console.log("handleSuccessDelete")
    this2.refresh();
}

export const handlePostWithResult = async (path, param, then2, this2) => {
    axios.post(path, param)
        .then((res) => then2(res.data))
        .catch(error => {
            if (error && error.response && error.response.data && Array.isArray(error.response.data.errors)) {
                console.log(error.response.data);
                error.response.data.errors.map((element, index) => {
                    return this2.props.enqueueSnackbar(getMessage(element), { variant: 'error', persist: true });
                })
            } else {
                console.log(error);
                console.log(error.response);
            }
        })
};